import axios from 'axios';

const baseURL = 'api/Pregunta';

async function getActual(usuario, idEje) {
    const { data } = await axios.get(baseURL + "/actual?idUsuario=" + usuario.id + "&idEje=" + idEje + "&language=" + usuario.language,
    {
        headers: {
            'token': usuario.token
        }
    }
    );

    return data;
}
async function getPreguntasTemas(language){
    const { data } = await axios.get(baseURL + "/preguntasTemas?language=" + language);
    return data;
}

export default { getActual, getPreguntasTemas };